import { render, staticRenderFns } from "./modalSolicitarActualiza.vue?vue&type=template&id=2c4d5f7d"
import script from "./modalSolicitarActualiza.vue?vue&type=script&lang=js"
export * from "./modalSolicitarActualiza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports